<div class="charts-container">
  <div class="chart">
    <img src="assets/health-charts/balance-history.png" />
  </div>

  <div class="chart">
    <img src="assets/health-charts/heart-rate.png" />
  </div>
  <div class="chart">
    <img src="assets/health-charts/poc.png" />
  </div>
  <div class="chart">
    <img src="assets/health-charts/mii-care.png" />
  </div>
</div>
